import React from 'react';
import { Badge, Fab, Tooltip } from '@mui/material';
import { ShoppingCart as ShoppingCartIcon } from '@mui/icons-material';
import { CART_FAB_GLOW_SX } from '../../../../super-picker/components/common';

/**
 * Floating compare-cart button — mirrors the agent's compare FAB in
 * `SuperPickerApp.tsx` (~line 28785): `ShoppingCartIcon` inside a
 * badge, lifted above the share FAB on mobile.
 */
interface FloorPlanCompareFabProps {
  count: number;
  onClick: () => void;
}

export const FloorPlanCompareFab: React.FC<FloorPlanCompareFabProps> = ({ count, onClick }) => {
  if (count <= 0) return null;
  return (
    <Tooltip title="Compare floor plans">
      <Fab
        color="primary"
        aria-label="compare floor plans"
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: { xs: 84, sm: 92 },
          right: { xs: 16, sm: 24 },
          zIndex: (theme) => theme.zIndex.modal - 1,
          ...CART_FAB_GLOW_SX,
        }}
      >
        <Badge badgeContent={count} color="error">
          <ShoppingCartIcon />
        </Badge>
      </Fab>
    </Tooltip>
  );
};

export default FloorPlanCompareFab;
